/* SAVIO DE — kleine, abhängigkeitsfreie Interaktionen. */
(function () {
  'use strict';

  /* ---------- FAQ / Akkordeon ---------- */
  function initFaq(root) {
    var buttons = (root || document).querySelectorAll('.savio-de-faq__q');
    Array.prototype.forEach.call(buttons, function (btn) {
      if (btn.dataset.savioBound === '1') return;
      btn.dataset.savioBound = '1';
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) {
          panel.removeAttribute('data-open');
          panel.setAttribute('hidden', '');
        } else {
          panel.setAttribute('data-open', 'true');
          panel.removeAttribute('hidden');
        }
      });
    });
  }

  /* ---------- Produktgalerie: nebeneinander + Pfeile ---------- */
  function initGallery(root) {
    var galleries = (root || document).querySelectorAll('[data-de-gal]');
    Array.prototype.forEach.call(galleries, function (gal) {
      if (gal.dataset.savioBound === '1') return;
      gal.dataset.savioBound = '1';

      var track = gal.querySelector('[data-de-track]');
      var prev = gal.querySelector('[data-de-prev]');
      var next = gal.querySelector('[data-de-next]');
      var dots = Array.prototype.slice.call(gal.querySelectorAll('[data-de-dot]'));
      var counter = gal.querySelector('[data-de-counter]');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.children);
      if (slides.length < 2) return;

      function current() {
        // Das Slide, dessen Mitte der Mitte des Viewports am naechsten liegt.
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0;
        var bestDist = Infinity;
        slides.forEach(function (s, i) {
          var c = s.offsetLeft + s.offsetWidth / 2;
          var d = Math.abs(c - mid);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        return best;
      }

      function goTo(i) {
        var idx = Math.max(0, Math.min(slides.length - 1, i));
        var s = slides[idx];
        if (!s) return;
        track.scrollTo({
          left: s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2,
          behavior: 'smooth'
        });
      }

      function sync() {
        var i = current();
        dots.forEach(function (d, di) { d.setAttribute('aria-current', di === i ? 'true' : 'false'); });
        if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
      }

      if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
      if (next) next.addEventListener('click', function () { goTo(current() + 1); });
      dots.forEach(function (d, di) { d.addEventListener('click', function () { goTo(di); }); });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { sync(); ticking = false; });
      }, { passive: true });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current() - 1); }
      });

      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------- In den Warenkorb -> SAVIO Cart Drawer ---------- */
  function initAtc(root) {
    var forms = (root || document).querySelectorAll('form[data-de-atc]');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.dataset.savioBound === '1') return;
      form.dataset.savioBound = '1';

      form.addEventListener('submit', function (e) {
        // Ohne Drawer faellt das Formular auf das normale Shopify-Verhalten zurueck.
        if (!window.SavioCart || typeof window.SavioCart.addItems !== 'function') return;

        var idEl = form.querySelector('[name="id"]');
        if (!idEl || !idEl.value) return;

        e.preventDefault();

        var qtyEl = form.querySelector('[name="quantity"]');
        var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
        if (!qty || qty < 1) qty = 1;

        var btn = form.querySelector('button[type="submit"]');
        var label = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.innerHTML = '…'; }

        function restore() {
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
        }

        window.SavioCart.addItems([{ id: Number(idEl.value), quantity: qty }])
          .then(restore)
          .catch(function (err) {
            console.error(err);
            restore();
            form.submit();
          });
      });
    });
  }

  function boot(root) {
    initFaq(root);
    initGallery(root);
    initAtc(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
